<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="part" id="_idParaDest-23">Act II</h1>
<h2 class="subtitle">Mystery</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PastImperative22.vue?01cd1c60